module.exports = __webpack_public_path__ + "TiemposFine-SemiboldItalic.svg?c38aad967589b654b0aa53c18e003d63";